import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Hi, I'm Tyler O'Brien`}</h1>
    <p>{`I'm a student studying Computer Science. I mostly program in Unity/C#, have decent experience in Typescript/React, and some experience in PHP/C/Java/Python.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      